import { StatusDueDate } from '@/components/DueDate';
import { RequestWithRelationsFromRequestsList } from '@/models/request';

export const StepDueDate = ({
  request,
  variant,
}: {
  request: RequestWithRelationsFromRequestsList;
  variant: 'card' | 'row';
}) => {
  if (!request.statusDueAt) {
    return variant === 'row' ? <>-</> : null;
  }

  return (
    <StatusDueDate
      date={new Date(request.statusDueAt)}
      variant={variant}
      displayDayMonthOnly={variant === 'card'}
    />
  );
};
